<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">정기권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountcharge" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 신청</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
            <li><router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link></li>
            <!-- <li><router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 신청</h3>
        <article>
          <!--table pc-->
          <div class="table horizontal-table web">
            <table>
              <caption>
                정기권 신청 결과 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름</th>
                  <td>{{ periodInfo.waitingNm }}</td>
                </tr>
                <tr>
                  <th scope="row">주소</th>
                  <td colspan="3">{{ periodInfo.zipcode }} {{ periodInfo.addr }} {{ periodInfo.addrDetail }}</td>
                </tr>
                <tr>
                  <th scope="row">휴대폰번호</th>
                  <td colspan="3">{{ periodInfo.telNo }}</td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장</th>
                  <td>{{ periodInfo.sectnNm }}</td>
                  <th scope="row">배정방식</th>
                  <td>{{ periodInfo.periodAllotTypeKor }}</td>
                </tr>
                <tr>
                  <th scope="row">주차구분</th>
                  <td v-if="this.periodInfo.useDivCd == 'UTM-001'">전일</td>
                  <td v-else-if="this.periodInfo.useDivCd == 'UTM-002'">주간</td>
                  <td v-else>야간</td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>{{ periodInfo.carNo }}</td>
                  <th scope="row">차량 소유주명</th>
                  <td>{{ periodInfo.carOwnerNm }}</td>
                </tr>
                <tr>
                  <th scope="row">할인자격</th>
                  <td colspan="3">{{ periodInfo.discountNm }}</td>
                </tr>
                <tr>
                  <th scope="row">할인자격 변경</th>
                  <td colspan="3">{{ periodInfo.discountCg.text }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table pc-->

          <!--table mobile-->
          <div class="table horizontal-table mobile">
            <table>
              <caption>
                정기권 신청 결과 테이블
              </caption>
              <colgroup>
                <col style="width: 35%" />
                <col style="width: 65%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름</th>
                  <td>{{ periodInfo.waitingNm }}</td>
                </tr>
                <tr>
                  <th scope="row">주소</th>
                  <td>{{ periodInfo.zipcode }} {{ periodInfo.addr }} {{ periodInfo.addrDetail }}</td>
                </tr>
                <tr>
                  <th scope="row">휴대폰번호</th>
                  <td>{{ periodInfo.telNo }}</td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장</th>
                  <td>{{ periodInfo.sectnId }}</td>
                </tr>
                <tr>
                  <th scope="row">배정방식</th>
                  <td>{{ periodInfo.periodAllotTypeKor }}</td>
                </tr>
                <tr>
                  <th scope="row">주차구분</th>
                  <td v-if="this.periodInfo.useDivCd == 'UTM-001'">전일</td>
                  <td v-else-if="this.periodInfo.useDivCd == 'UTM-002'">주간</td>
                  <td v-else>야간</td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>{{ periodInfo.carNo }}</td>
                </tr>
                <tr>
                  <th scope="row">차량 소유주명</th>
                  <td>{{ periodInfo.carOwnerNm }}</td>
                </tr>
                <tr>
                  <th scope="row">할인자격</th>
                  <td>{{ periodInfo.discountCd.text }}</td>
                </tr>
                <tr>
                  <th scope="row">할인자격 변경</th>
                  <td>{{ periodInfo.discountCg.text }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table mobile-->
        </article>
        <article class="btnArea">
          <button type="button" class="btn gray" @click="$router.push('/periodapplication')">취소</button>
          <button type="button" class="btn blue" @click="showModal">확인</button>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-match v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="savePeriod">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-match>
    <alert-match v-show="applicationSuccess">
      <template #content>
        <p>{{ msg2 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="moveToChk">확인</button>
        </article>
      </template>
    </alert-match>
  </main>
</template>

<script>
import AlertMatch from '../../../components/Alert01.vue';
import axios from '../../../util/axios';

export default {
  data() {
    return {
      showModalMsgSuccess: false,
      applicationSuccess: false,
      dupChk: false,
      msg: '정기권을 신청하시겠습니까?',
      msg2: '정기권 신청이 성공하였습니다.',
      periodInfo: {
        addr: '',
        carNo: '',
        telNo: '',
        sectnNm: '',
        zipcode: '',
        extraCd: '',
        useDivCd: '',
        waitingNm: '',
        addrDetail: '',
        carOwnerNm: '',
        discountCd: {},
        discountCg: {},
        periodAllotType: '',
        startDttm: '',
        endDttm: '',
      },
    };
  },

  components: {
    AlertMatch,
  },

  mounted() {
    const data = this.$route.params.data;
    if (!data) {
      alert('잘못된 접근입니다.');
      this.$router.push('/periodinfo');
      return;
    }
    this.periodInfo = data;
  },

  methods: {
    CancleBtn() {
      this.showModalMsgSuccess = false;
    },
    showModal() {
      this.showModalMsgSuccess = true;
    },
    async savePeriod() {
      let apiParams = new FormData();
      apiParams.append('sectnId', this.periodInfo.sectnId);
      apiParams.append('waitingNm', this.periodInfo.waitingNm);
      apiParams.append('carOwnerNm', this.periodInfo.carOwnerNm);
      apiParams.append('carNo', this.periodInfo.carNo);
      apiParams.append('telNo', this.periodInfo.telNo);
      apiParams.append('addr', this.periodInfo.addr);
      apiParams.append('addrDetail', this.periodInfo.addrDetail);
      apiParams.append('zipcode', this.periodInfo.zipcode);
      apiParams.append('useDivCd', this.periodInfo.useDivCd);
      apiParams.append('startDttm', this.periodInfo.startDttm);
      apiParams.append('endDttm', this.periodInfo.endDttm);
      if (this.periodInfo.discountCg.id != 'DC001' && this.periodInfo.discountCg != '') {
        apiParams.append('discountCd', this.periodInfo.discountCg.id);
      } else {
        apiParams.append('discountCd', this.periodInfo.discountCd);
      }
      if (this.periodInfo.eFiles) {
        apiParams.append('file', this.periodInfo.eFiles);
      }
      const res = await axios('post', '/api/period/insertAction.json', apiParams);
      const data = res.data.value;
      if (data.result) {
        this.showModalMsgSuccess = false;
        this.applicationSuccess = true;
      } else {
        if (data.message.includes('중복됩니다')) {
          this.msg2 = data.message;
          this.showModalMsgSuccess = false;
          this.applicationSuccess = true;
          this.dupChk = true;
        }
      }
      // console.error(data.message);
    },
    moveToChk() {
      if (this.dupChk) {
        this.$router.push('/periodapplication');
        return;
      }
      this.$router.push('/periodlookup');
    },
  },
};
</script>
